<ion-item [class.text-red]="submitted && ((address && !address.postalCode) || !address)" (click)="beginChangeAddress()">
  <p style="white-space: pre;">
    {{ text }}
  </p>
  <ion-icon name="arrow-forward" slot="end"></ion-icon>
</ion-item>